<textarea
  appInput
  [formControl]="formControl"
  [cols]="to.cols"
  [rows]="to.rows"
  class="input-element"
  [formlyAttributes]="field"
></textarea>
